/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'
import {
    getFinanceOrderListByCreatedUserId,
    setFinanceMarketCostStatus, setFinanceRepeatOrderStatus
} from '@/api/financial-center'

import {getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {formatDate} from '@/utils/timeFilter'


@Component({})
export default class RepeatOrder extends Vue {
    invoiceNumTitle = '订单/回款编号：'  //订单回款编号label
    customerId: number  //客户id
    customerType: string  //客户类型
    marketCooperationId: number  //合作伙伴id
    select = '1'  //回款编号
    options = [
        {label: '客户名称', value: '0'},
        {label: '订单/回款编号', value: '1'},
    ]

    logList = []

    customerNameOrMarketCooperationName = ''


    orderDialog = false  //学生订单列表
    partnersOrderDialog = false  //合作伙伴订单列表
    receivableDialog = false
    orderDialogInputValue = ''
    receivableDialogInputValue = ''
    orderDialogTaleData = []
    receivableDialogTaleData = []
    orderDialogTotal = 0
    receivableDialogTotal = 0
    orderDialogPage = 1
    receivableDialogPage = 1
    orderDialogTableLoading = false
    receivableDialogTableLoading = false
    orderDialogSelectTable = []
    formData = {
        aRatio: '',
        bRatio: ''
    }
    directorUserRealName = ''
    // directorUserId = ''
    createdUserRealName = ''
    amount = ''
    tableDataOrder = []
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    orderId: number = null
    tableRandom = Math.random()
    feeTypeList = [
        {label: '合作顾问额外奖励', value: '0'},
        {label: '中小顾问积分奖励', value: '1'},
        {label: '学生奖学金申请', value: '2'},
        {label: '市场活动费用', value: '3'},
        {label: '其他', value: '4'}
    ] // 费用类型
    operationShow = true
    backMoneyStatus = ''
    showInput: any = false
    type = ""
    status: any
    costId = NaN
    isUpdatedData = '0'
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    cancelReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    // eImageurls = []
    // tableDataOrder = [] //明细列表
    formRules = {
        'formData.types': [{required: true, message: '请选择费用类型', trigger: 'change'}],
    }
    disBtn = false
    // elImageUrls = []

    editFiles = {
        account: null,
        backMoneyAt: null,
        financeBackMoneyProofList: null
    }
    previewPath = []
    previewVisible = false
    editFileList = []
    financeOrderId = ''
    createdAt = ''
    repeatUserRealName = ''
    explain = ' '
    // directorUserId = ' '
    repeatOrderId = ''
    repeatOrderInfo = {}
    isRequired = false
    financeRepeatOrderUser = {}
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    loading = false
    isNotReject = false

    get eImageurls() {
        return this.repeatOrderInfo ?( this.repeatOrderInfo as any).financeRepeatOrderExplainList.map(item => item.url) : []
    }



    get userName() {
        return UserModule.userName
    }



    get directorUserId() {
        return UserModule.userId
    }


    menuBtn = menuBtn
    formatDate = formatDate


    created() {
        this.approval_id = Number(this.$route.query.approval_id)
        this.types = this.$route.query.types as string
        this.getMessageReviewById()
        this.approval_type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string

    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    handlePreview(file) {
        this.previewPath = [file.url]
        this.previewVisible = true
    }

    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.approval_type !== '0') return false
        if (this.editFileList != undefined && this.editFileList != null) {
            // console.log('88888',this.editFileList.some(item => item.file === key))
            return this.editFileList.some(item => item.file === key)
        }
    }

    uploadSuccess(res) {
        const {data} = res
        this.$message.success('上传成功')
        this.editFiles.financeBackMoneyProofList.push({name: data.name, url: data.ossUrl})
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    handleUploadRemove(file) {
        this.editFiles.financeBackMoneyProofList = this.editFiles.financeBackMoneyProofList.filter(item => item.uid !== file.uid)
    }


    async getMessageReviewById() {
        this.loading = true
        await getMessageReviewById(this.approval_id,this.types).then((data: any)=>{
            const data1 = data.result.financeRepeatOrderDetail
            this.repeatOrderId = data.result.id
            this.tableDataOrder[0] = data1
            this.repeatOrderInfo = data.result
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.logList = data.result.messageReviewLogList
            this.financeOrderId = data.result.financeOrderId
            this.editFileList = data.result.editFileList
            // this.eImageurls = data.result.financeRepeatOrderExplainList
            this.amount = data1.financeOrderPrice
            // this.directorUserRealName = data.result.financeRepeatOrderUser.directorUserRealName
            this.financeRepeatOrderUser = data.result.financeRepeatOrderUser
            if (this.editFileList && this.editFileList.length > 0) this.isRequired = this.approval_type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
            this.formData.aRatio = data.result.aRatio
            this.formData.bRatio = data.result.bRatio
            this.stepNode.isFirstNode = data.result.isFirstNode
            this.stepNode.isSyncEkuaibao = data.result.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = data.result.isSyncEqianbao
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    openReviewDialog(status: number) {
        // this.status = status
        const newObj = this.formData
        if(this.isRequired && this.status === 1) {
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    this.$message.error('请将编辑的信息填写完整')
                    return false
                }
            }
        }
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'approveId', this.approval_id)
        this.$set(this.approvedData, 'editFiles', this.formData)
        this.approvedVisible = true
    }

    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    reviewDialogConfirm() {
        // const newObj = this.formData
        // const obj = {
        //     messageReviewId: this.approval_id,
        //     status: this.status,
        //     opinion: this.opinion,
        //     form: this.status === 1 ? newObj : {},
        //     nodeType: this.nodeType,
        //     // isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
        // }
        // this.disBtn = true
        // setMessageReviewUserByMessageReviewId(obj).then(() => {
        //     this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
        //     setTimeout(() => {
        //         window.close()
        //     }, 1500)
        // }).catch((err) => {
        //     this.disBtn = false
        // })
    }

    // approvedConfirm() {
    //     const newObj = this.formData
    //     const obj = {
    //         messageReviewId: this.approval_id,
    //         status: this.status,
    //         opinion: this.opinion,
    //         form: this.status === 1 ? newObj : {},
    //         // nodeType: this.nodeType,
    //         isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
    //     }
    //     this.disBtn = true
    //     for(const key in obj) {
    //         if(obj[key].length === 0 || !obj[key]) {
    //             delete obj[key]
    //         }
    //     }
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err) => {
    //         this.disBtn = false
    //     })
    // }
    // 订单列表
    choiceOrder(e) {
        this.orderDialog = true
        this.getCustomerNameListByFinanceMarketCost()
        e.target.blur()
    }

    // 合作伙伴、学生列表
    async getCustomerNameListByFinanceMarketCost() {
        const obj = {
            customerName: this.orderDialogInputValue,
            page: this.orderDialogPage,
            limit: 20
        }
        const data: any = await getFinanceOrderListByCreatedUserId(delNullProperty(obj))
        this.orderDialogTaleData = data.financeOrderList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false
        this.tableRandom = Math.random()
    }


    getRowKeys(row) {
        return `${row.code}`
    }


    // 订单确认事件
    // orderDialogConfirm() {
    //     this.formData.financeOrderId = this.orderDialogSelectTable[0].id
    //     this.orderDialog = false
    // }


    // 订单列表change
    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
    }

    // 订单
    handleOrderRowClick(row) {
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }


    orderDialogPageChange(page: number) {
        this.orderDialogPage = page
    }

    receivableDialogPageChange(page: number) {
        this.receivableDialogPage = page
    }

    closePage() {
        window.close()
    }

    // changeTypes() {
    //     this.formData.score = ''
    //     this.formData.price = ''
    // }

    // 撤回审批
    async cancelApproval() {
        await setFinanceRepeatOrderStatus({id: Number(this.repeatOrderId), action: '1'})
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.cancelReview = false
    }

    clickAddOrder() {

        // this.select = '0'
        // this.currentPage = 1
        // this.orderDialogInputValue = ''
        // this.customerName = ''
        // this.sourceName = ''
        // this.orderDialog = true
        // this.getFinanceOrderListByCreatedUserId()
        // this.defaultChecked()
    }


    // 驳回审批
    clickRejectButton(status: number) {
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.approval_id)
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        // this.nodeType = data.rejectNode
        // this.opinion = data.reviewIdea
        // this.approvalVisible = false
        // this.reviewDialogConfirm()
        this.approvalVisible = false
    }

    /*
    * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }


    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        // this.opinion = data.reviewIdea
        // this.isAgreeRevoke = data.isAgreeRevoke
        // this.approvedVisible = false
        // this.approvedConfirm()
        this.approvedVisible = false
    }
}
